<ion-header>

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title>
      <div translate>DEV_OPTIONS.TITLE</div>
    </ion-title>
  </ion-toolbar>

</ion-header>

<ion-content class="ion-padding page2" no-bounce>

  <ion-list>
    <!--button ion-item (click)="resetMorningInteraction()"><div translate>DEV_OPTIONS.RESET_MORNING_INTERACTION</div></button-->
    <!--button ion-item (click)="resetNightInteraction()"><div translate>DEV_OPTIONS.RESET_NIGHT_INTERACTION</div></button-->
    <ion-item>
      <ion-label ion-item>Version: {{appVersion}}</ion-label>
    </ion-item>
    <ion-item>
      <ion-label ion-item>Build: {{appBuild}}</ion-label>
    </ion-item>
    <ion-item>
      <ion-label ion-item>Platform: {{platforms}}</ion-label>
    </ion-item>
    <ion-item>
      <ion-label ion-item>BuildTime: {{buildTime}}</ion-label>
    </ion-item>
    <ion-item>
      <ion-label ion-item>User: {{profile?.email}}</ion-label>
    </ion-item>
    <ion-item>
      <ion-label ion-item>Company: {{profile?.company?.name}}</ion-label>
    </ion-item>
    <ion-item>
      <ion-label ion-item>TargetGroup: {{targetGroup}}</ion-label>
    </ion-item>
    <ion-item>
      <ion-label ion-item>Episoden-Kontrollgruppe: {{kontrollGroup}}</ion-label>
    </ion-item>
    <ion-item>
      <ion-button fill="fill" expand="block" color="light" shape="round" (click)="onOnboarding()" translate>DEV_OPTIONS.START_ONBOARDING</ion-button>
    </ion-item>
    <ion-item>
      <ion-button fill="fill" expand="block" color="light" shape="round" (click)="onResetInstructions()" translate>DEV_OPTIONS.RESET_INSTRUCTIONS</ion-button>
    </ion-item>
    <ion-item>
      <ion-button fill="fill" expand="block" color="light" shape="round" (click)="onModeInitial()" translate>DEV_OPTIONS.START_MODE</ion-button>
    </ion-item>
    <ion-item>
      <ion-label ion-item translate>DEV_OPTIONS.CONTENT_IMMEDIATELY</ion-label>
      <ion-checkbox slot="end" [(ngModel)]="contentImmediately" (ionChange)="setContentImmediately()"></ion-checkbox>
    </ion-item>
    <ion-item>
      <ion-label ion-item translate>DEV_OPTIONS.EPISODES</ion-label>
      <ion-checkbox slot="end" [(ngModel)]="ep_monday" (ionChange)="setEpisodes($event, 'MONDAY')" translate>DEV_OPTIONS.MONDAY</ion-checkbox>
      <ion-checkbox slot="end" [(ngModel)]="ep_friday" (ionChange)="setEpisodes($event, 'FRIDAY')" translate>DEV_OPTIONS.FRIDAY</ion-checkbox>
    </ion-item>
    <!--ion-item>
      <ion-label ion-item translate>DEV_OPTIONS.DESKTOP_LAYOUT_DISABLED</ion-label>
      <ion-checkbox slot="end" [(ngModel)]="desktopLayoutDisabled" (ionChange)="setDesktopLayoutDisabled()"></ion-checkbox>
    </ion-item-->
  </ion-list>

</ion-content>
